import { DelimitedTextFormatter } from 'field-kit';
export default class CAPostalCodeFormatter extends DelimitedTextFormatter {
  constructor() {
    super(' ', /* isLazy = */true);
    // six alphanumeric characters and a single space delimiter
    this.maximumLength = 7;
  }
  hasDelimiterAtIndex(index) {
    return index === 3;
  }
  isChangeValid(change, error) {
    if (/^\w*$/.test(change.inserted.text)) {
      return super.isChangeValid(change, error);
    } else {
      return false;
    }
  }
}